import MessageContentParser from './MessageContentParser';
import { cn } from '../../lib/utils';

interface MessageContentProps {
  isUser: boolean;
  isLastMessage?: boolean;
  loading?: boolean;
  sanitizedFormattedText: string;
  sanitizedDisplayResponse: string;
}

function MessageContent({
  isUser,
  isLastMessage,
  loading,
  sanitizedFormattedText,
  sanitizedDisplayResponse,
}: MessageContentProps) {
  if (isUser) {
    return <p>{sanitizedFormattedText}</p>;
  }

  const content = isLastMessage && !loading ? sanitizedDisplayResponse : sanitizedFormattedText;

  return (
    <MessageContentParser
      content={content}
      className={cn(
        '[&_a]:underline [&_a]:text-blue-400',
        isLastMessage && !loading && 'min-h-[22px]',
      )}
    />
  );
}

export default MessageContent;
